// ABOUTME: Category definitions + logo lookup for the melding `type` picker.
// ABOUTME: Four groups — shippers / webshops / API & printnode / ERPs. Logos pulled from logomapper.js + accountingSoftware.js; auto-generated colors wrap each one.

import { getShipperLogo, getWebshopLogoNoSize, marketPlaceAppIconsMap, normalizeMarketPlaceName, getExternalChannelLogo } from "../../../../utils/logomapper";
import { getLogoElement as getAccountingLogoElement } from "../../../../utils/accountingSoftware";

export const MELDING_TYPE_CATEGORIES = [
    {
        id: "shipper",
        label: "shippers",
        items: [
            { id: "postnl", label: "PostNL" },
            { id: "dhl", label: "DHL" },
            { id: "dhlgermany", label: "DHL Germany" },
            { id: "dpd", label: "DPD" },
            { id: "ups", label: "UPS" },
            { id: "gls", label: "GLS" },
            { id: "parcel", label: "Parcel" },
            { id: "cirro", label: "Cirro" },
            { id: "sendcloud", label: "Sendcloud" },
            { id: "innosend", label: "Innosend" },
            { id: "innosendv2", label: "Innosend V2" },
            { id: "intrapost", label: "Intrapost" },
            { id: "myparcel", label: "MyParcel" },
            { id: "myparcelcom", label: "MyParcel.com" },
            { id: "ampere", label: "Ampere" },
            { id: "trunkrs", label: "Trunkrs" },
            { id: "cycloon", label: "Cycloon" },
            { id: "hst", label: "HST" },
            { id: "zineps", label: "Zineps" },
            { id: "bol_shipper", label: "Bol Shipping" },
        ],
    },
    {
        id: "webshop",
        label: "webshops",
        items: [
            // Webshop platforms
            { id: "magento", label: "Magento" },
            { id: "shopify", label: "Shopify" },
            { id: "woocommerce", label: "WooCommerce" },
            { id: "ccvshop", label: "CCV Shop" },
            { id: "lightspeed", label: "Lightspeed" },
            { id: "plugandpay", label: "PlugAndPay" },
            { id: "prestashop", label: "PrestaShop" },
            { id: "etailize", label: "Etailize" },
            { id: "mirakl", label: "Mirakl" },
            { id: "productflow", label: "Productflow" },
            // Marketplaces
            { id: "alltricks", label: "Alltricks" },
            { id: "amazon", label: "Amazon" },
            { id: "amazon_stockhub", label: "Amazon Stockhub" },
            { id: "anwb", label: "ANWB" },
            { id: "autodoc", label: "Autodoc" },
            { id: "bigbang", label: "BigBang" },
            { id: "blokker", label: "Blokker" },
            { id: "bol", label: "Bol" },
            { id: "brico", label: "Brico" },
            { id: "carrefour", label: "Carrefour" },
            { id: "castorama", label: "Castorama" },
            { id: "conforama", label: "Conforama" },
            { id: "conrad", label: "Conrad" },
            { id: "debijenkorf", label: "De Bijenkorf" },
            { id: "decathlon", label: "Decathlon" },
            { id: "douglas", label: "Douglas" },
            { id: "eleclerc", label: "E.Leclerc" },
            { id: "eprice", label: "ePRICE" },
            { id: "fonq", label: "fonQ" },
            { id: "home24", label: "Home24" },
            { id: "hornbach", label: "Hornbach" },
            { id: "inno", label: "INNO" },
            { id: "jardiland", label: "Jardiland" },
            { id: "kaufland", label: "Kaufland" },
            { id: "kleertjes", label: "Kleertjes" },
            { id: "kruidvat", label: "Kruidvat" },
            { id: "laposte", label: "La Poste" },
            { id: "leenbakker", label: "Leen Bakker" },
            { id: "leroymerlin", label: "Leroy Merlin" },
            { id: "mdm", label: "MdM" },
            { id: "mediamarkt", label: "MediaMarkt" },
            { id: "metromakro", label: "Metro/Makro" },
            { id: "obelink", label: "Obelink" },
            { id: "pccomponentes", label: "PcComponentes" },
            { id: "pixmania", label: "Pixmania" },
            { id: "praxis", label: "Praxis" },
            { id: "rueducommerce", label: "Rue du Commerce" },
            { id: "secretsales", label: "Secret Sales" },
            { id: "shopapotheke", label: "Shop Apotheke" },
            { id: "venteunique", label: "Vente-unique" },
            { id: "vidaxl", label: "vidaXL" },
            { id: "vtwonen", label: "vtwonen" },
            { id: "worten", label: "Worten" },
            { id: "yoox", label: "Yoox" },
        ],
    },
    {
        id: "other",
        label: "other",
        items: [
            { id: "api", label: "API" },
            { id: "openapi", label: "OpenAPI" },
            { id: "printnode", label: "PrintNode" },
            { id: "prediko", label: "Prediko" },
            { id: "returnless", label: "Returnless" },
        ],
    },
    {
        id: "erp",
        label: "erps",
        items: [
            { id: "moneybird", label: "Moneybird" },
            { id: "afas", label: "AFAS" },
            { id: "stockhub_pdf", label: "Stockhub PDF" },
        ],
    },
];

const buildIndex = () => {
    const idx = {};
    for (const cat of MELDING_TYPE_CATEGORIES) {
        for (const item of cat.items) {
            idx[item.id] = { ...item, categoryId: cat.id, categoryLabel: cat.label };
        }
    }
    return idx;
};

const TYPE_INDEX = buildIndex();

export const findMeldingType = (id) => (id ? TYPE_INDEX[id] || null : null);

// Returns a JSX logo node for the given type id, or null if no SVG mapping exists.
// The marketplace svgs live in logomapper as marketPlaceAppIconsMap — match by normalized id.
export const getMeldingTypeLogo = (id, size = 32) => {
    if (!id) return null;
    const entry = TYPE_INDEX[id];
    if (!entry) return null;

    if (entry.categoryId === "shipper") {
        const shipperKey = id === "bol_shipper" ? "bol" : id;
        return getShipperLogo(shipperKey);
    }

    if (entry.categoryId === "webshop") {
        // Try platform svg first.
        const platform = getWebshopLogoNoSize(id);
        if (platform) return platform;
        // Fall back to marketplace svg.
        const normalized = normalizeMarketPlaceName(id);
        const match = marketPlaceAppIconsMap.find((icon) => normalized.includes(icon.name));
        if (match) {
            const Icon = match.Icon;
            return <Icon width={size} height={size} />;
        }
        return null;
    }

    if (entry.categoryId === "erp") {
        return getAccountingLogoElement(id, size, size);
    }

    if (entry.categoryId === "other") {
        if (id === "prediko" || id === "returnless") {
            return getExternalChannelLogo(id);
        }
        return null;
    }

    return null;
};
